import script from "./Tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=4da17954&scoped=true&lang=scss"
script.__scopeId = "data-v-4da17954"

export default script